<template>
  <div id="app" class="app" :class="theme">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import config from './config'
export default {
  computed: {
    ...mapState({
      theme: state => state.theme
    })
  },
  mounted(){
    document.body.className = document.body.className.replace('loading',' ') + config.class
    document.title = config.title
  }
}
</script>